import React from 'react';

import { FlagsProvider } from '@atlaskit/flag/flag-provider';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { EmbedRouteLoader } from '@confluence/confluence-embeds';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

import SpaceBase from '../../SpaceBase/index.js';
import { LazyDwellTime, LazyConsumptionViewedAndCompletedEventTracker } from '../lazyComponents.js';

export const EmbedViewRoute = ({ params: { contentId, spaceKey } }: RouteMatch) => (
	<>
		<SpaceBase>
			<FlagsProvider>
				<EmbedRouteLoader contentId={contentId} spaceKey={spaceKey} />
			</FlagsProvider>
		</SpaceBase>
		<LazyDwellTime />
		<LazyConsumptionViewedAndCompletedEventTracker spaceKey={spaceKey} source="EmbedViewRoute" />
	</>
);

EmbedViewRoute.NAVIGATION_PARAMS = ({
	name: routeName,
	params: { contentId, spaceKey },
}: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'smartLinkEmbedPageScreen',
			id: contentId,
			attributes: {
				contentId,
				contentType: 'embed',
			},
		},
		pageState: {
			contentId,
			spaceKey,
			contentType: 'embed',
			routeName,
		},
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
		isViewPage: true,
	},
});
